import { Button } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { closeAndClearActiveFilterTabMenu } from '../helpers/conversations-filter-helpers';
import { useMessagingStore } from '../hooks/use-messaging-store';
import { useNewConversationCancellationModal } from '../hooks/use-new-conversation-cancellation-modal';

export const MessagingBookmarksButton = observer(function MessagingBookmarksButton({
    setShowAllConversations,
}: {
    setShowAllConversations?: (value: boolean) => void;
}): React.ReactElement {
    const {
        isBookmarksView,
        setIsBookmarksView,
        isCreatingNewConversation,
        selectedConversationFilter,
        setSelectedConversationKey,
        setActiveFilterTabMenu,
    } = useMessagingStore();

    const {
        setIsOpen,
        updateConfirmCancellationStoredData,
    } = useNewConversationCancellationModal();

    const { isFirstResponder } = useApplicationType();

    const handleClick = () => {
        if (isFirstResponder && setShowAllConversations && !isCreatingNewConversation) {
            setShowAllConversations(true);
        }

        closeAndClearActiveFilterTabMenu({
            filterType: selectedConversationFilter?.filterType,
            setActiveFilterTabMenu,
        });

        if (isCreatingNewConversation) {
            updateConfirmCancellationStoredData?.('bookmarks-view');
            setIsOpen?.(true);
        } else {
            setIsBookmarksView(true);
            setSelectedConversationKey(undefined);
        }
    };

    return (
        <Button
            data-testid="bookmarks-view-button"
            disabled={isBookmarksView}
            variant={isFirstResponder ? 'outline' : 'ghost'}
            leadingVisual="Bookmark"
            onClick={handleClick}
        >
            Bookmarks
        </Button>
    );
});
